// Login.js
// Purpose: Handles user login via email and manages login state and navigation.
// Logic: Uses React hooks, reducer, and axios to process login and redirect on success.

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useReducer, useState } from "react";
import { initialState, reducer } from "../components/ReducerComponent";
import { useLocation, useNavigate } from "react-router-dom";
import ThreeDotsLoader from "../components/ThreeDotsLoader";
import axios from "axios";
import {
  clog,
  getRedirectAfterLogin,
  setRedirectAfterLogin,
} from "../lib/utils";

function Login() {
  const [loadingState, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();
  const [signUpdata, setsignUpdata] = useState({
    email: "",
  });
  const location = useLocation();
  const [versionMessage, setVersionMessage] = useState("");
  clog(location, "location...");

  // Debug: Check both location.state and localStorage using utility function
  useEffect(() => {
    const redirectInfo = getRedirectAfterLogin(location?.state);
    console.log("Location state:", location?.state);
    console.log("Redirect info (combined):", redirectInfo);

    // Check for version update message
    const message = sessionStorage.getItem("version_update_message");
    if (message) {
      setVersionMessage(message);
      sessionStorage.removeItem("version_update_message");
    }
  }, [location]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setsignUpdata({ ...signUpdata, [id]: value });
  };
  // Function to handle login button click
  const loginButton = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOADING" });
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/vison/login`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          email: signUpdata.email,
        },
      });
      if (response.data.success) {
        console.log(location?.state, "location state...");

        // Use utility function to get redirect info
        const redirectInfo = getRedirectAfterLogin(location?.state);

        navigate("/login-otp", {
          replace: true,
          state: {
            email: signUpdata.email,
            from: redirectInfo?.from || "login",
            url: redirectInfo?.url || "script",
          },
        });
      } else {
        dispatch({
          type: "ERROR",
          data: {
            errorMessage: response.data.message,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        data: {
          errorMessage: error?.response?.data?.msg,
        },
      });
      clog(error);
    }
  };
  // Effect to check if user is already logged in and redirect
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (localStorage.getItem("login_token")) {
      navigate("/script");
    }

    let error = searchParams.get("error");
    if (error) {
      dispatch({
        type: "ERROR",
        data: {
          errorMessage: error,
        },
      });
      // window.location.href = window.location.origin + window.location.pathname;
    }
    const referrer = searchParams.get("referrer");
    const page_url = searchParams.get("page_url");
    if (referrer) {
      localStorage.setItem("referrer", referrer);
    }

    if (page_url) {
      localStorage.setItem("page_url", page_url);
    }
  }, []);

  return (
    <>
      <div className="h-screen">
        <img
          className="loginfram w-full h-full absolute z-[-10]"
          src="images/frame.png"
          alt="..."
        />
        {/* Navigation button to landing page */}
        <div className="absolute top-6 right-8 z-10">
          <button
            type="button"
            onClick={() =>
              window.open(process.env.REACT_APP_LANDING_URL, "_self")
            }
            className="px-6 py-2 rounded-full font-semibold border-2 border-[#1A71A7] text-[#1A71A7] hover:bg-[#1A71A7] hover:text-white transition duration-300 flex items-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back to Home
          </button>
        </div>
        <div class="flex flex-wrap -mx-6l h-screen">
          <div class="w-full md:w-1/2 px-[80px] flex items-center justify-center">
            <div className="w-[560px]">
              <img className="w-full" src="images/signin-left.png" alt="..." />
            </div>
          </div>
          <div class="w-full md:w-1/2 px-[80px] flex items-center">
            <form className="w-full" onSubmit={loginButton}>
              <div
                className="flex justify-center cursor-pointer"
                onClick={() => window.open(process.env.REACT_APP_LANDING_URL)}
              >
                {/* <img src="images/logo.png" alt="..." /> */}
                <img
                  src="images/VisonWithOReplaced.png"
                  width={150}
                  height={50}
                  alt="..."
                />
              </div>
              <h5 className="font-extrabold text-[40px] py-6">Sign In</h5>
              {versionMessage && (
                <div className="w-full mb-4 p-4 bg-blue-50 border border-blue-300 rounded-lg text-blue-800 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="font-medium">{versionMessage}</span>
                  </div>
                </div>
              )}
              <label
                className="block mb-2 font-semibold text-[20px]"
                htmlFor="email"
              >
                Work Email Address
              </label>
              <input
                type="email"
                id="email"
                className="w-full rounded-full mb-[20px] font-[400] text-[20px] border border-[#E9EBF0] bg-[#FAFBFC]"
                placeholder="Work Email Address"
                required
                onChange={handleChange}
                value={signUpdata.email}
                pattern="[^@\s]+@[^@\s]+\.[^@\s]+" // Email validation
                title="Please enter a valid email address"
              />
              {loadingState.error && (
                <div className="w-full text-[red] py-2 text-center">
                  {loadingState.errorMessage}
                </div>
              )}
              <button
                type="submit"
                disabled={loadingState.loading}
                className="w-full mt-2 justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7]"
              >
                {loadingState.loading ? (
                  <div className="flex justify-between items-center">
                    <div></div>
                    <div>Logging In</div>
                    <div>
                      <ThreeDotsLoader />
                    </div>
                  </div>
                ) : (
                  "Continue"
                )}
              </button>
              <div
                className="py-6 text-center font-bold text-[18px] cursor-pointer"
                onClick={() => {
                  navigate("/signup");
                }}
              >
                <span>Not A Member </span>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className="text-transparent bg-clip-text bg-gradient-to-r from-[#1A71A7] to-[#9D3784] hover:from-[#9D3784] hover:to-[#1A71A7]">
                  Sign Up
                </a>
              </div>
              <h3 className="title-around-span my-3 pt-1">
                <span>Or</span>
              </h3>

              <button
                type="button"
                className="w-full my-6 mt-2 justify-center py-2 px-[20px] rounded-[20px] font-semibold border border-[#D73939] text-[#D73939] relative hover:bg-[#D73939] hover:text-[#ffffff] transition duration-700"
                onClick={() => {
                  // Store redirect info before external redirect to Google
                  const redirectInfo = getRedirectAfterLogin(location?.state);
                  if (redirectInfo?.from || redirectInfo?.url) {
                    setRedirectAfterLogin(redirectInfo);
                  }

                  window.open(
                    `${process.env.REACT_APP_BASE_SIGNIN_URL}/auth/google`,
                    "_self"
                  );
                }}
              >
                <span className="absolute left-[20px] top-[6px]">
                  <svg className="icon text-[28px]">
                    <use href="#icon_google"></use>
                  </svg>
                </span>
                Continue With Google
              </button>
              <div className="bg-red-50 border-2 border-red-400 rounded-lg p-3 mt-3 mb-4">
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5 text-red-600 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <p className="text-red-700 font-semibold text-sm">
                    Work email only - Gmail and public email providers are not
                    allowed
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
